<template>
  <div class="calculation section-block section-block--bg-white">
    <div class="calculation__container">
      <div class="calculation__heading">
        {{ store.translations.CalculationHeading }}
      </div>
      <div class="calculation__subheading-estimation">
        {{ store.calculateSeedVolume ? store.translations.SubHeadingEstimation : store.translations.SubHeadingActual }}
      </div>

      <div class="calculation__estimation-content">
        <section class="calculation__estimation">
          <div class="calculation__sum"  v-if="store.isValidForm">
            {{ store.calculateSeedVolume ? getFormattedNumber(store.seedsPerUnit) : getFormattedNumber(store.seedPopulation )}}
          </div>
          <div class="calculation__unit">
            {{ !store.calculateSeedVolume ? store.translations.Seeds : store.translations.Plants }}/{{ store.metric ? store.translations.M2 : store.translations.Ft2 }}
          </div>
        </section>

        <section class="calculation__estimation">
          <div class="calculation_sums" v-if="store.isValidForm">
            <span v-if="store.metric">
              {{ store.calculateSeedVolume ? getFormattedNumber(store.plantsPerAreaUnit) : getFormattedNumber(store.actualSeedVolumeAreaUnit) }}
          </span>
            <span v-else>
              {{ store.calculateSeedVolume ? getFormattedNumber(store.plantsPerAreaUnit) : getFormattedNumber(store.actualSeedVolumeAreaUnit) }}
            </span>
          </div>
          <div class="calculation__unit">
            {{ !store.calculateSeedVolume ? store.translations.Seeds : store.translations.Plants }}/{{ store.metric ? store.translations.Ha : store.translations.Acres }}
          </div>
        </section>

        <section class="calculation__estimation" v-if="!store.calculateSeedVolume">
          <div class="calculation_sums" v-if="store.isValidForm">
            <div class="calculation__sum">
              {{ getFormattedNumber(store.actualSeedVolumeWeightArea) }}
            </div>
          </div>
          <div class="calculation__unit">
            {{ store.metric ? `${store.translations.Kg}/${store.translations.Ha}` : `${store.translations.Lb}/${store.translations.Acres}` }}
          </div>
        </section>
      </div>

      <div class="calculation__summation">
        <div class="calculation__summation-text" v-if="store.isValidForm">
          {{ store.translations.CalculationText }} {{ store.fieldSize }}
          {{ store.metric ? store.translations.Ha : store.translations.Acres }}
        </div>

        <div class="calculation__summation-sum" v-if="store.isValidForm">
          <div v-if="store.calculateSeedVolume">
            {{ getFormattedNumber(store.estimatedSeedVolume) }} {{ store.metric
              ? `${store.translations.Kg}`
              : `${store.translations.Pounds}` }}
          </div>
          <div v-else>
            {{ getFormattedNumber(store.actualSeedVolumeWeight) }} {{ store.metric
              ? `${store.translations.Kg}`
              : `${store.translations.Pounds}` }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useSeedRateCalculatorStore} from '../store/store.js';
import { getFormattedNumber } from '../Services/seedRateUtilities';

const store = useSeedRateCalculatorStore();
</script>